import React, { useState,useEffect } from 'react';
import "./WakeUpCall.css";
import Header from '../../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../../customHooks/useAuth';
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../common/baseUrl';
import PageLoader from '../../components/PageLoader/PageLoader';
import axiosInstance from '../../../axiosInstance/axiosInstance';
import { getCurrentUser } from '../../../common/currentUser';
import { HOTEL_TIMEZONE, toHotelISO } from "../../../common/hotelTime";
import Dropdown from "../../components/Dropdown/Dropdown";

export default function WakeUpCall() {

    const location = useLocation();
    const navigate = useNavigate();
    
    const bookedRooms = location.state?.bookedRooms || [];
    const userId = localStorage.getItem("user_id");

    const hotelId = location.state?.hotelId || "";
    const bookingId = location.state?.bookingId || "";
    const hotelAddress = location.state?.hotelAddress || "";
    const hotelName = location.state?.hotelName || '';
    const checkInDate = location.state?.checkInDate || "";
    const checkOutDate = location.state?.checkOutDate || "";
    const status = location.state?.status || "";
    const activeTab = location.state?.activeTab || "";
    const booking_code = location.state?.booking_code || "";

    // Refresh Handle
    useAuth();


    // Get today's and tomorrow's date
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const [formData,setFormData] = useState({
        time : "",
        serviceDate : "",
        room : "",
        comment : ""
    });

    const [isLoading,setIsLoading] = useState(false);

    const [errors, setErrors] = useState({});


    // Check Data 
    useEffect(()=>{
        const checkId = ()=>{
            if(hotelId==="" || bookingId===""){
                navigate("/bookings");
            }
        }
        checkId();
    },[hotelId,bookingId,navigate]);

    // Format Date
    const formatDate = (date) => {
        return date.toLocaleDateString('en-GB', {
            timeZone: HOTEL_TIMEZONE,
        day: 'numeric',
        month: 'short',
        });
    };


    // Function to handle date selection
    const handleDateSelection = (selectedDate) => {
        setFormData((prevState) => ({
        ...prevState,
        serviceDate: selectedDate,
        }));
        validateField("serviceDate",selectedDate);
    };

    // OnChange
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        validateField(name,value);
    };


    // Validation Form
    const validateForm=()=>{
        const newErrors = {};
        if (!formData.time.trim()) {
            newErrors.time = "time is required";
        }
        if (!formData.serviceDate.trim()) {
            newErrors.serviceDate = "Date is required";
        }
        if (!formData.room.trim()) {
            newErrors.room = "Room selection is required";
        }
        // if(!formData.comment.trim()){
        //     newErrors.comment = "Comment selection is required";
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors

    }


    // Validate Field
    const validateField =(field,value)=>{
        const newErrors = { ...errors };
        switch (field) {

            case "time":
                if (!value.trim()) {
                    newErrors.time = "Time is required";
                } else {
                    newErrors.time = "";
                }
                break;

            case "serviceDate":
                if (!value.trim()) {
                    newErrors.serviceDate = "Date is required";
                } else {
                    newErrors.serviceDate = "";
                }
                break;

            case "room":
                if (!value.trim()) {
                    newErrors.room = "Room Selection is required";
                } else {
                    newErrors.room = "";
                }
                break;
            // case "comment":
            //     if (!value.trim()) {
            //         newErrors.comment = "Room Selection is required";
            //     } else {
            //         newErrors.comment = "";
            //     }
            //     break;

            default:
                break;
        }
        setErrors(newErrors);
    }


    // Submit Handler
    const handleSubmit = async()=>{
        try{
            if(!validateForm()){
                // console.log("Form Has Some Errors ")
                return;
            }
            setIsLoading(true);

            // Combine selected date and time into ISO 8601 format
            // Get current year
            const currentYear = new Date().getFullYear();
            // Combine selected date and time into ISO 8601 format
            const selectedDate = new Date(`${formData.serviceDate} ${currentYear}`); // Add current year
            const [hours, minutes] = formData.time.split(':');

            // Set the time to the selected date
            selectedDate.setHours(hours);
            selectedDate.setMinutes(minutes);
            selectedDate.setSeconds(0);


            // Format function without converting to UTC
            // Get the formatted date-time with specified offset
            const isoDateTimeWithInd = toHotelISO(selectedDate);
            // console.log("Date with Offset: ", isoDateTimeWithInd);
            // Convert to ISO format
            // const isoDateTime = selectedDate.toISOString();
            // console.log("Date : ",isoDateTime);



            const currentUser = await getCurrentUser();
 
            function findMatchedRooms(bookedRooms, usersData) {
                const contact = usersData.contact;
                const matchedRooms = bookedRooms.filter((room)=>{
                    // Check if guests are null or an empty array, and skip the room if true
                    if (!room.guests || room.guests.length === 0) {
                        return false; // Skip this room
                    }
                    const matchedGuest = room.guests.find((guest)=>guest.contact===contact);
                    if(matchedGuest) {
                        return true; //
                    }
                    else{
                        return false;
                    }
                });
                return matchedRooms;
            }        

            const usersData = currentUser;  
            const matchedRooms = findMatchedRooms(bookedRooms, usersData);

            if(matchedRooms.length<=0){
                // console.log("Booking is not Present ");
                return;
            }
            // console.log("MAtched Rooms : " + matchedRooms[0].id);
      

            // console.log("Form Data : ",formData);
            const roomData = bookedRooms.find(item=>item.id===formData.room);
            // console.log("Room Number : ",roomData.room_number);

            const passData = {
                "date_time" : isoDateTimeWithInd,
                "service_room": roomData.room_number,
                "additional_comments": formData.comment
            }
            // console.log("Data To Be Submitted : ",passData);

            const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${matchedRooms[0].id}/guest-requests/post-checkin/wakeup-call-request/`,passData); 
            // console.log("Success Request Added : ",response.data);

            toast.success("Wake Up Call Request Created Successfully");
            navigate("/bookings",{state : {activeRequests : "requests"}});
        
        }catch(error){
            toast.error(error?.response?.data?.message || "Some Error Occured");
            console.log(error);
        }
        finally{
            setIsLoading(false);
        }
    }

  return (
    <>
        {
            isLoading && <PageLoader/>
        }
        <div className='wakeUpCall'>
            <Header title="Wake up call"  
                hotelName = {hotelName}
                hotelAddress = {hotelAddress}
                checkInDate = {checkInDate}
                checkOutDate = {checkOutDate}
                status = {status}
                activeTab = {activeTab}
                hotelId = {hotelId}
                bookingId = {bookingId}
                movetoHotel = "movetoHotel"
                booking_code = {booking_code}
            />
            <div className='wakeUpCall-data'>

                {/* Date */}
                <div className='wake-fields'>
                    <div className='wake-name'>
                        <h4>Date of service</h4>
                    </div>
                    <div className='date-selection'>
                        <div
                        className={`date-box ${formData.serviceDate === formatDate(today) ? 'selected' : ''}`}
                        onClick={() => handleDateSelection(formatDate(today))}
                        >
                            {formatDate(today)}  
                        </div>
                        <div
                        className={`date-box ${formData.serviceDate === formatDate(tomorrow) ? 'selected' : ''}`}
                        onClick={() => handleDateSelection(formatDate(tomorrow))}
                        >
                            {formatDate(tomorrow)}  
                        </div>
                    </div>
                    {errors.serviceDate && <p className="error-message">{errors.serviceDate}</p>}
                </div>
                
                {/* When You Want to Wake Up */}
                <div className='wake-fields'>
                    <div className='wake-name'>
                        <h4>When do you want to be woken up</h4>
                    </div>
                    <div className='wake-inp'>
                        <input type='time' name="time" value={formData.time} onChange={handleChange} />
                        {errors.time && <p className="error-message">{errors.time}</p>}
                    </div>
                </div>
                
                {/* Comments */}
                <div className='wake-fields'>
                    <div className='wake-name'>
                        <h4>Comments</h4>
                    </div>
                    <textarea name="comment" rows='4' cols="10" value={formData.comment} onChange={handleChange} ></textarea>
                    {errors.comment && <p className="error-message">{errors.comment}</p>}
                </div>

                {/* Service Rooms and Button Selection  */}
                <div className='wake-fields'>
                    <div className='wake-name'>
                        <h4>Service Room</h4>
                    </div>
                    <div className='wake-inpguests'>
                        <div className='wakeSelect'>
                            <Dropdown
                                name="room"
                                value={formData.room}
                                onChange={handleChange}
                                placeholder="Select a room"
                                options={bookedRooms
                                    .filter(room => room.room_number)
                                    .map(room => ({ value: room.id, label: String(room.room_number) }))}
                            />
                            {errors.room && <p className="error-message">{errors.room}</p>}
                        </div>
                        <div className='wake-btn'>
                            <button onClick={handleSubmit} disabled={formData.serviceDate==="" || formData.time==="" || formData.room===""} >Send Request</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </>
  )
}
